import PersonalForm from './personal-form';

export default PersonalForm;
